import { identify, makeRequest, Service } from 'utils/http';

type Data = {
  workspaceId: string;
};

export async function adminGetWorkspaceApi({ workspaceId }: Data) {
  return makeRequest(Service.adminGetWorkspace(workspaceId, await identify()));
}
